import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { user_profileActions } from 'actions';
import { BasicSpinner } from '../../../../../components';

export function LastLoginTile({ userId }) {
  const [lastLogin, setLastLogin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    user_profileActions
      .fetchLastLogin(userId)
      .then((data) => { if (!cancelled) setLastLogin(data && data.status === 'ok' ? data.last_login : null); })
      .catch(() => { if (!cancelled) setLastLogin(null); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  return (
    <div className="statistics-summary-tile">
      <div className="statistics-summary-tile__label">Last Login</div>

      {loading && (
        <div className="d-flex justify-content-center py-2">
          <BasicSpinner />
        </div>
      )}

      {!loading && !lastLogin && (
        <div className="statistics-summary-tile__empty">Never logged in</div>
      )}

      {!loading && lastLogin && (
        <div className="statistics-summary-tile__value">
          {format(new Date(lastLogin), 'MMM d, yyyy h:mmaaa')}
        </div>
      )}
    </div>
  );
}

export default LastLoginTile;
